module.exports = __webpack_public_path__ + "static/media/CAS_Logo.3b2a193e.png";